<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <div>
      <div v-if="!disableButton">
        <authorized-link tag="create_tax">
          <router-link :to="{ path: 'taxes/new'}" class="ls-btn-primary ls-no-margin ls-float-right">{{ $t('taxes.buttons.new_tax') }}</router-link>
        </authorized-link>
      </div>
      <br clear="all">
      <filter-tax></filter-tax>
      <div>
        <table class="ls-table ls-sm-space ls-table-striped" v-if="taxes.length">
          <thead>
            <tr>
              <th>{{ $t('taxes.attributes.id') }}</th>
              <th>{{ $t('taxes.attributes.name') }}</th>
              <th>{{ $t('taxes.attributes.value') }}</th>
              <th>{{ $t('taxes.attributes.scope') }}</th>
              <th>{{ $t('taxes.attributes.status') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr data-test="tax" v-for="(tax, index) in taxes">
              <td data-test="tax.id">{{ tax.id }}</td>
              <td data-test="tax.name">{{tax.name}}</td>
              <td data-test="tax.value" class="ls-no-padding-right">{{ (tax.value) }}%</td>
              <td data-test="tax.scope">{{ tax.scope}}</td>
              <td :class="tax.active ? 'active-tax' : 'inactive-tax' "><span data-test="tax.status" class="ls-display-inline-block">{{ $t('taxes.attributes.statuses.' + tax.active) }}</span></td>
              <td>
                <router-link slot="button" :to="{ name: 'tax_details', params: { id: tax.id }}" class="ls-btn ls-no-margin ls-float-right">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                  <span class="ls-display-none-xs">{{ $t('application.button.detail') }}</span>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else role="alert">
          <empty-list></empty-list>
        </div>
        <pagination :updater="getTaxes"></pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import Filter from './components/Filter'
  import Pagination from 'src/app/components/shareds/pagination/Pagination'
  import Dropdown from 'src/app/components/shareds/dropdown/Dropdown'
  import Regroup from 'src/app/components/shareds/regroup/Regroup'
  import Browser from 'src/utils/browser'
  import _ from 'lodash'
  import filter from 'src/utils/filter'
  import scroll from 'src/utils/scroll'
  import EmptyList from 'src/app/components/shareds/empty-list/EmptyList'

  export default {
    name: 'IndexTaxes',
    components: {
      Breadcrumb,
      FilterTax: Filter,
      Pagination,
      Dropdown,
      Regroup,
      EmptyList
    },
    data () {
      return {
        index: '',
        crumbs: {
          'ico': 'ls-ico-docs',
          'section': this.$t('taxes.main.list_taxes'),
          'paths': {
            0: {
              'title': this.$t('taxes.main.title'),
              'path': ''
            }
          }
        },
        updateTaxes: false,
        hasTaxes: true
      }
    },
    mounted () {
      this.updateTaxes = true
      this.getFromUrl()
      this.getTaxes()
      this.$watch('taxes', function (newVal, oldVal) {
        this.setPageData(newVal)
      })
    },
    computed: {
      ...mapGetters(['taxes', 'filterTaxes', 'pagination', 'currentUser']),
      disableButton () {
        if (window.localStorage.getItem('offline') === 'true') {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      ...mapActions(['loadTaxes']),
      ...mapMutations(['setPageData', 'clearFilterTaxes', 'setTaxes']),
      getTaxes () {
        this.$loader.show()
        var params = filter.toQueryWithPagination(this.filterTaxes, this.pagination, 10)
        this.saveOnUrl()
        this.loadTaxes(params).then(this.afterLoad)
      },
      getFromUrl () {
        Browser.recoverFilterFromURL(this.$route, this.filterTaxes, this.pagination)
      },
      saveOnUrl () {
        var paginationUrlParams = { current_page: this.pagination.current_page, per_page: this.pagination.per_page }
        Browser.filtersToURL(this.$router, _.merge(this.filterTaxes, paginationUrlParams), 'taxes')
      },
      afterLoad () {
        this.$loader.hide()
        if (this.updateTaxes) this.hasTaxes = this.taxes.length > 0
        this.updateTaxes = false
      },
      setInactiveData (tax, index) {
        this.setTax(tax)
        this.inactiveObjects.index = index
        this.inactiveObjects.show = true
        this.inactiveObjects.callback = scroll.scrollToFlash
      }
    },
    beforeDestroy () {
      this.clearFilterTaxes()
    }
  }
</script>
<style scoped lang="scss">
  .inactive-tax {
    background: #f2f2f2!important;
    color: #8c8c8c;
  }
  .active-tax {
    background-color: #b2e1b3!important;
    color: #388f39;
  }
</style>



// WEBPACK FOOTER //
// Main.vue?778529e2